module.exports = __webpack_public_path__ + "assets/img/17-l.079b772.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/17-l.jpg
// module id = cfsg
// module chunks = 0